import React from "react";
import { Container } from "react-bootstrap";

export const Orders: React.FC = () => {

    return(
        <React.Fragment>
            <Container fluid className="p-0">
                Orders......
            </Container>
        </React.Fragment>
    );
}